"use client"
import MatchStepper from "../../components/matchs/match-stepper"

export default function CreateMatch() {
  return (
    <div className="min-h-screen bg-white p-6">
      <div className="flex items-center mb-6">
        <span className="bg-primary-700 w-1 h-6 mr-3 rounded"></span>
        <h2 className="text-xl font-bold text-primary-950 flex items-center">Create Match</h2>
      </div>
      <MatchStepper />
    </div>
  )
}
